import * as companyAction from './company-action'

export {
  companyAction,
}



// WEBPACK FOOTER //
// ./src/actions/company/index.js